

import { useState } from "react";
import "./header.scss";

import {
  FaPhoneAlt,
  FaEnvelope,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaFacebookF,
  FaCalendarAlt,
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";

import { Link } from "react-router-dom";
import logo from "../images/header-image/logo.png";

import AppointmentModal from "./AppointmentModal";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [appointmentOpen, setAppointmentOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  return (
    <>
      {/* TOP BAR */}
      <div className="top-bar">
        <div className="top-left">
          <span>
            <FaPhoneAlt />{" "}
            <a href="tel:+919205020856">
              <b className="phone-number">+91 92050 20856</b>
            </a>
          </span>
          <span>
            <FaEnvelope /> <b>ilagupta.ivf@gmail.com</b>
          </span>
        </div>

        <div className="top-right">
          <div className="social-icons">
            <a
              href="https://twitter.com/dr_ila_gupta"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>

            <a
              href="https://www.instagram.com/Ilaguptaivf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com/company/ilaguptaivf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>

            <a
              href="https://www.facebook.com/ivfallindia"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
          </div>

          <button
            className="appointment-btn"
            onClick={() => setAppointmentOpen(true)}
          >
            <FaCalendarAlt /> BOOK APPOINTMENT NOW
          </button>
        </div>
      </div>

      {/* HEADER */}
      <header className="main-header">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Logo" />
          </Link>
        </div>

        {/* DESKTOP MENU */}
        <nav className="nav-menu">
          <Link to="/">HOME</Link>

          <Link to="/about">ABOUT DR. ILA GUPTA</Link>

          {/* SERVICES MEGA MENU */}
          <div className="nav-item has-mega">
            <span>
              SERVICES <FaChevronDown />
            </span>

            <div className="mega-dropdown">
              <div className="mega-grid">
                <div className="mega-col">
                  <Link to="/infertility-treatment-in-delhi">
                    INFERTILITY TREATMENT
                  </Link>

                  <Link to="/blastocyst-transfer">
                    BLASTOCYST TRANSFER
                  </Link>

                  <Link to="/oocyte-and-embryo-freezing">
                    OOCYTE & EMBRYO FREEZING
                  </Link>

                  <Link to="/fertility-enhancing-laparoscopy-and-hysteroscopy">
                    LAPAROSCOPY & HYSTEROSCOPY
                  </Link>
                </div>

                <div className="mega-col">
                  <Link to="/artificial-insemination-iui">
                    ARTIFICIAL INSEMINATION (IUI)
                  </Link>

                  <Link to="/donor-egg-ivf">
                    DONOR EGG IVF
                  </Link>

                  <Link to="/testicular-aspiration-or-tesa">
                    TESA / PESA
                  </Link>
                </div>

                <div className="mega-col">
                  <Link to="/ivf-treatment-in-delhi">
                    IVF TREATMENT
                  </Link>

                  <Link to="/imsi">
                    IMSI
                  </Link>

                  <Link to="/donor-sperm-ivf">
                    DONOR SPERM IVF
                  </Link>

                  <Link to="/microtesa">
                    MICRO TESA
                  </Link>
                </div>

                <div className="mega-col">
                  <Link to="/icsi">
                    ICSI
                  </Link>

                  <Link to="/assisted-hatching">
                    ASSISTED HATCHING
                  </Link>

                  <Link to="/surrogacy">
                    SURROGACY
                  </Link>

                  <Link to="/pre-genetic-screening-and-diagnosis">
                    PGT SCREENING
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <Link to="/gallery">GALLERY</Link>
          <Link to="/testimonials">TESTIMONIALS</Link>
          <Link to="/media">MEDIA</Link>
          <Link to="/blog">BLOGS</Link>
          <Link to="/videos">VIDEOS</Link>
          <Link to="/contact">CONTACT</Link>
        </nav>

        {/* MOBILE MENU BUTTON */}
        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <FaTimes /> : <FaBars />}
        </button>
      </header>

      {/* MOBILE MENU */}
      {mobileOpen && (
        <div
          className="mobile-menu-overlay"
          onClick={() => setMobileOpen(false)}
        >
          <nav
            className="mobile-menu"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="mobile-close"
              onClick={() => setMobileOpen(false)}
            >
              <FaTimes />
            </button>

            <Link to="/" onClick={() => setMobileOpen(false)}>
              HOME
            </Link>

            <Link to="/about" onClick={() => setMobileOpen(false)}>
              ABOUT DR. ILA GUPTA
            </Link>

            {/* SERVICES ACCORDION */}
            <div className="mobile-accordion">
              <div
                className="accordion-header"
                onClick={() => setServicesOpen(!servicesOpen)}
              >
                <span>SERVICES</span>

                <FaChevronDown
                  className={servicesOpen ? "rotate" : ""}
                />
              </div>

              {servicesOpen && (
                <div className="accordion-body">
                  <Link to="/infertility-treatment-in-delhi">
                    Infertility Treatment
                  </Link>

                  <Link to="/ivf-treatment-in-delhi">
                    IVF Treatment
                  </Link>

                  <Link to="/icsi">
                    ICSI
                  </Link>

                  <Link to="/imsi">
                    IMSI
                  </Link>

                  <Link to="/artificial-insemination-iui">
                    IUI
                  </Link>

                  <Link to="/donor-egg-ivf">
                    Donor Egg IVF
                  </Link>

                  <Link to="/donor-sperm-ivf">
                    Donor Sperm IVF
                  </Link>

                  <Link to="/blastocyst-transfer">
                    Blastocyst Transfer
                  </Link>

                  <Link to="/assisted-hatching">
                    Assisted Hatching
                  </Link>

                  <Link to="/surrogacy">
                    Surrogacy
                  </Link>

                  <Link to="/pre-genetic-screening-and-diagnosis">
                    PGT Screening
                  </Link>
                </div>
              )}
            </div>

            <Link to="/gallery">GALLERY</Link>
            <Link to="/testimonials">TESTIMONIALS</Link>
            <Link to="/media">MEDIA</Link>
            <Link to="/blog">BLOG</Link>
            <Link to="/videos">VIDEOS</Link>
            <Link to="/contact">CONTACT</Link>
          </nav>
        </div>
      )}

      {/* APPOINTMENT FORM MODAL */}
      <AppointmentModal
        appointmentOpen={appointmentOpen}
        setAppointmentOpen={setAppointmentOpen}
      />
    </>
  );
};

export default Header;